import React, { Component } from "react";
import Cookies from "universal-cookie";
import appConstants from "../../../appConstants";
import SubscriptionPlan from "../../Subscriptionplan";
import { Link } from "react-router-dom";
const cookie = new Cookies();

class Footer extends Component {
  constructor(props) {
    super(props);
    let clinicDetail = cookie.get("clinic", { path: "/" }) || {};
    this.state = {
      clinicDetail: clinicDetail,
      subscriptionPlanModal: false,
    };
  }

  showHideSubscriptionDetails(value, e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      subscriptionPlanModal: value,
    });
  }

  render() {
    let { clinicDetail, subscriptionPlanModal } = this.state;
    return (
      <React.Fragment>
        {clinicDetail &&
        clinicDetail.subscriptionPlan &&
        clinicDetail.subscriptionPlan ===
          appConstants.subscriptionPlan.free.name ? (
          <div className="footer-container mt-2">
            <div className="text-heading-bg p-2 d-flex algin-item-center justify-content-between footer-custom ">
              <p className="mb-0">
                you are currently on the lite plan, upgrade to unlock more
                capabilities
              </p>
              <p className="mb-0 redirect-to-clnic-details">
                {/* <Link to="/clinicdetail">
                  <b>upgrade your account Now!</b>
                </Link> */}
                <a
                  onClick={() => this.setState({ subscriptionPlanModal: true })}
                >
                  <b>upgrade your account Now!</b>
                </a>
              </p>
            </div>
          </div>
        ) : null}
        {subscriptionPlanModal ? (
          <SubscriptionPlan
            hidePopup={this.showHideSubscriptionDetails.bind(this, false)}
          />
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

export default Footer;
